<template>
  <md-card
    class="md-card-fancy"
    :class="{ 'md-card-hidden': cardHidden }"
  >
    <md-card-header :class="getClass(headerColor)">
      <slot name="title" />
    </md-card-header>

    <md-card-content>
      <slot name="cardContent" />
    </md-card-content>

    <md-card-actions>
      <slot name="footer" />
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
    name: "FancyCard",
    props: {
        headerColor: {
            type: String,
            default: "primary"
        }
    },
    data() {
        return {
            cardHidden: true
        };
    },
    beforeMount() {
        setTimeout(this.showCard, 400);
    },
    methods: {
        showCard: function() {
            this.cardHidden = false;
        },
        getClass: function(headerColor) {
            return "md-card-header-" + headerColor + "";
        }
    }
};
</script>

<style lang="css"></style>
